import React, { useState } from "react";
import { LuMapPin, LuUser } from "react-icons/lu";
import { getUser } from "../../lib/authToken";
import PauseToggle from "../liveOrder/PauseToggle";
import UserProfileModal from "./UserProfileModal";


export default function Header() {
  const user = getUser();
  const [showProfileModal, setShowProfileModal] = useState(false);

  return (
    <header className="header">
      <div className="header-left">
        <h1>{user?.name}</h1>
        <div className="loc">
          <LuMapPin className="loc-ico" />
          <span className="loc-text">{user?.location}</span>
        </div>
      </div>

      <div className="header-right">
        <PauseToggle />
        <div className="profile" onClick={() => setShowProfileModal(true)} style={{ cursor: "pointer" }}>
          <div className="profile-meta">
            <div className="profile-name">{user?.name}</div>
          </div>
          <div className="avatar">
            <LuUser size={20} />
          </div>
        </div>
      </div>

      <UserProfileModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
    </header>
  );
}
